import { Badge } from '@liveauctioneers/hammer-ui-core/badge';
import { LabelStrong } from '@liveauctioneers/hammer-ui-core/text';

import ConsoleSocialBadge from '@/components/ConsoleSocial/ConsoleSocialBadge';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogAbsenteeBidders,
    getCatalogHasVideo,
    getCatalogIsDone,
    getCatalogIsTimedPlus,
    getCatalogIsTimedPlusClosing,
    getShouldShowLive,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogBidders, getLiveCatalogStatus } from '@/redux/modules/console';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    catalogId: number;
};

export const HomepageAuctionCardBadge = ({ catalogId }: Props) => {
    const formatMessage = useAppFormatMessage();
    const hasVideo = useAppSelector((state) => getCatalogHasVideo(state, catalogId));
    const isDone = useAppSelector((state) => getCatalogIsDone(state, catalogId));
    const showLive = useAppSelector((state) => getShouldShowLive(state, catalogId));
    const isTimedPlus = useAppSelector((state) => getCatalogIsTimedPlus(state, catalogId));
    const isTimedPlusClosing = useAppSelector((state) => getCatalogIsTimedPlusClosing(state, catalogId));
    const liveStatus = useAppSelector((state) => getLiveCatalogStatus(state, catalogId));
    const bidders = useAppSelector((state) => getLiveCatalogBidders(state, catalogId));
    const absenteeBidders = useAppSelector((state) => getCatalogAbsenteeBidders(state, catalogId));

    const live = (showLive || liveStatus === 'live') && !isTimedPlus;
    const viewers = bidders + absenteeBidders;

    if (isTimedPlus && !isDone && isTimedPlusClosing) {
        return (
            <Badge
                className="absolute left-xs top-xs"
                color="critical"
                emphasis="bold"
                size="sm"
            >
                <LabelStrong className="uppercase text-text-inverse">{formatMessage(['closing'])}</LabelStrong>
            </Badge>
        );
    }

    if (live) {
        return (
            <ConsoleSocialBadge
                className="absolute left-xs top-xs"
                hasVideo={hasVideo}
                viewers={viewers}
            />
        );
    }

    return null;
};
